// @flow
import React from 'react';
import CarContainer from './containers/CarContainer';

export type Props = $ReadOnly<{|
    cars: $ReadOnlyArray<string>,
    showBothSources?: boolean
|}>;

function Cars({ cars, showBothSources }: Props) {
    return (
        <React.Fragment>
            {cars.map((icao) => (
                <React.Fragment key={icao}>
                    <CarContainer icao={icao} dataSource={showBothSources ? 'system' : 'auto'} debug={showBothSources} />
                    {showBothSources && <CarContainer icao={icao} dataSource="device" debug={showBothSources} />}
                </React.Fragment>
            ))}
        </React.Fragment>
    );
}

export default Cars;